// extracted by mini-css-extract-plugin
export default {"root":"checkboxCellRendererDecorator_root__gWUHD","value":"checkboxCellRendererDecorator_value__6jeI7"};